import { getAccount } from '@wagmi/core';
import { useAccount, useConnect } from 'wagmi';
import { InjectedConnector } from 'wagmi/connectors/injected';

import { CollectionChainType } from '@app/client';

import { type AddressInfo } from './types';
import { PETRA_INSTALL_URL } from './useConnectAnyWallet';

export function useWallets() {
    const { isConnected } = useAccount();

    const { connectAsync } = useConnect({
        connector: new InjectedConnector(),
    });

    // TODO: The functions below should be placed in a better location to avoid duplicated code
    function isPetraInstalled() {
        return 'aptos' in window;
    }

    function installPetra() {
        window.open(PETRA_INSTALL_URL, '_blank');
        return;
    }

    function getAptos() {
        if (isPetraInstalled()) {
            return window.aptos;
        } else {
            installPetra();
        }
    }

    async function getConnectedWallet(chain: CollectionChainType) {
        if (chain === CollectionChainType.Aptos) {
            const aptos = getAptos();
            if (!aptos) {
                throw new Error('Cound not find Aptos');
            }
            const wallet: AddressInfo = await aptos?.connect();
            return wallet.address;
        } else {
            if (!isConnected) {
                await connectAsync();
            }
            const account = await getAccount();
            return account.address as string;
        }
    }

    return {
        getConnectedWallet,
    };
}
